import { render, staticRenderFns } from "./photo-external.vue?vue&type=template&id=226851ff&scoped=true&"
import script from "./photo-external.vue?vue&type=script&lang=js&"
export * from "./photo-external.vue?vue&type=script&lang=js&"
import style0 from "./photo-external.vue?vue&type=style&index=0&id=226851ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226851ff",
  null
  
)

export default component.exports